module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "file_015"
    }
  }, [_vm._v("Working with Wool Fibers")])]), _c('a', {
    attrs: {
      "id": "file_015"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you have not yet had the pleasure of working with unspun wool, then you are in for a treat! It’s soft and smells sweet—just having a room full of wool is nice. Wool embodies all of the wonderful qualities of natural fibers. It absorbs and reflects light, holds warmth, and is gentle on your hands. And you are using a renewable material! Dyed wool roving is easy to find, thanks to the increasing interest in fiber arts and crafts. Unless the fiber is merino, it should be easy to use for needle felting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most of the unspun wool available in stores has already been washed and carded or combed into long ropes or what is called roving. Some wool roving is called top roving, which means that the wool has been combed rather than carded. Fibers felt better if they are laid crosswise rather than in the same direction as with roving. Wool batting is good to use because the fibers have not yet been combed or carded. Batting is coarser than roving, too, which is better for needle felting.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b94f06f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_015.vue
// module id = 99
// module chunks = 0